{"version":"26.10.23-local-solo","id":"at.softline.holzrentsch.softline","name":"Softline"}